import type { CustomErrorRule } from '@/core/error/transport/types'
import { EndpointsEnum } from '@/services/endpoints'
import { TmAuthVerificationInvalidCodeError } from '@/core/error/transport/auth/TmAuthVerificationInvalidCodeError'

export const authVerificationEmailCodeInvalidRule: CustomErrorRule = {
  endpoint: EndpointsEnum.registrationConfirmCodeFromEmail,
  subCodes: ['registration.invalid_code'],
  klass: TmAuthVerificationInvalidCodeError,
}
